// src/services/userProgressService.ts
import axios from 'axios';
import { API_CONFIG } from '../components/config/api';
import { isAuthenticated } from './authService';

/**
 * Interface für Sync-Ergebnisse
 */
export interface ProgressSyncResult {
  achievements_processed: number;
  achievements_completed: number;
  objectives_processed: number;
  objectives_completed: number;
  new_completions: number;
}

/**
 * Synchronisiert den Achievement-Fortschritt des Benutzers mit der Bungie API
 * @param characterId Optionale Character-ID für charakterspezifischen Fortschritt
 */
export const syncUserProgress = async (characterId?: string): Promise<ProgressSyncResult | null> => {
  if (!isAuthenticated()) {
    console.warn('Benutzer muss authentifiziert sein, um Fortschritt zu synchronisieren');
    return null;
  }

  try {
    const response = await axios.post(`${API_CONFIG.BASE_URL}/user/sync-progress`, { 
      character_id: characterId 
    });

    if (response.data.status === 'success') {
      const result = response.data.data;
      
      // Ausführlicheres Logging
      console.log('Sync completed with result:', result);
      console.log('Achievements processed:', result.achievements_processed);
      console.log('Achievements completed:', result.achievements_completed);
      console.log('Objectives processed:', result.objectives_processed);
      console.log('New completions:', result.new_completions);
      
      // Das Event wird jetzt in der SyncProgressButton-Komponente ausgelöst
      return result;
    }
    
    throw new Error(response.data.message || 'Failed to sync progress');
  } catch (error) {
    console.error('Error syncing user progress:', error);
    throw error;
  }
};